<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectCancelFutureLessons,
} from '../../../../model/additional-info/support/info-pause-subscription/select-cancel-future-lessons.hook'

defineOptions({
  name: 'SelectCancelFutureLessons',
})

const {
  placeholder,
  model,
  options,
} = useSelectCancelFutureLessons()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
